import React from 'react';
import {Modal, Pagination} from 'antd';
import {BaseComponent, request} from '@cm-sites-webber/components';
import Scrollbars from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import SearchTemplate from '../../../newMediaMatrix/components/searchTemplate/SearchTemplate';
import TableTemplate from '../../../newMediaMatrix/components/TableTemplate/TableTemplate';
import SortWay from "../list/sortWay/sortWay";
import {formatToDay, uuid} from "../../../../utils";

class EntryList extends BaseComponent {

    static propTypes = {
        styleOut: PropTypes.object,
    };
    static defaultProps = {
        styleOut: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            params: {
                pageNum: 1,
                pageSize: 10,
                query: "",
            },
            activityTypeItem: {},
            dataSource: [],
            total: 0,
        };

        this.columns = [
            {
                title: "账号名称",
                dataIndex: "name",
                key: "name",
                width: 250,
                ellipsis: true
            },
            {
                title: "媒体平台",
                dataIndex: "positionTypeName",
                key: "positionTypeName",
                width: 150,
                ellipsis: true,
                render: (text, record, index) => {
                    return <div title={text}
                                style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                        <img style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                            verticalAlign: "text-bottom",
                            marginRight: 5
                        }} src={record.logo}/>{text}
                    </div>
                }
            },
            {
                title: "账号状态",
                dataIndex: "statusName",
                key: "statusName",
                ellipsis: true
            },
            {
                title: "备案状态",
                dataIndex: "status",
                key: "status",
                ellipsis: true
            },
            {
                title: "最新年审时间",
                dataIndex: "annualAuditTime",
                render: (text,record,index) => {
                    return text ? formatToDay(text) : "-";
                }
            },
            {
                title: "更新时间",
                dataIndex: "updateTime",
                render: (text,record,index) => {
                    return text ? formatToDay(text) : "-";
                }
            },
            {
                title: "创建时间",
                dataIndex: "createTime",
                render: (text,record,index) => {
                    return text ? formatToDay(text) : "-";
                }
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                render: (text, record) => {
                    return <div style={{color: "#1890ff", cursor: "pointer"}} onClick={() => this.goHandle(record)}>
                        {"去" + this.state.activityTypeItem.name}
                    </div>;
                }
            }
        ];
    }

    goHandle = (record) => {
        const {goToItem} = this.props;
        goToItem && goToItem(record, this.state.activityTypeItem)
    }

    componentDidMount() {
    }

    refreshList = () => {
        this.getEntryListData();
    }

    // 表头搜索
    renderSearchTemplate() {
        const sortWay = (
            <SortWay ref={ref => this.sortWay = ref} options={[
                {
                    key: "createTime",
                    value: "createTime",
                    label: "创建时间"
                },
                {
                    key: "updateTime",
                    value: "updateTime",
                    label: "更新时间"
                }
            ]}
                defaultValue="createTime" refreshList={() => this.refreshList()} />
        )
        const btnList = [
            [
                {
                    type: 1,
                    key: "date",
                    component: sortWay,
                    labelName: "排序方式",
                    styleOut: {float: 'left'},
                },
                {
                    type: 2,
                    key: "search",
                    component: "search",
                    value: this.state.params.query,
                    placeholder: "请输入账号名称",
                    onChange: (e) => {
                        this.setState({params: {...this.state.params, query: e}})
                    },
                    onSearch: (e) => {
                        this.onSearch({query: e})
                    },
                    styleOut: {float: 'left'},
                },
                {
                    type: 2,
                    key: "reset",
                    component: "button",
                    labelName: "重置",
                    onChange: () => this.reset(),
                }
            ]
        ];
        return (
            <SearchTemplate
                btnList={btnList}
                onResize={() => {
                }}
            />
        )
    }

    // 表格
    renderTableTemplate() {
        return (
            <>
                <TableTemplate
                    columns={this.columns}
                    dataSource={this.state.dataSource}
                    onResize={() => {
                    }}
                />
            </>
        )
    }

    // 分页
    renderPagination() {
        const {total, params} = this.state;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'right',
                padding: '20px 32px',
                borderTop: "1px solid #e8e8e8",
                height: 72
            }}>
                <Pagination
                    // 是否可以改变 pageSize
                    showSizeChanger
                    // 是否可以快速跳转至某页
                    showQuickJumper
                    // pageSize 变化的回调
                    onShowSizeChange={(current, pageSize) => {
                        this.onPaginationChange(current, pageSize);
                    }}
                    onChange={(pageNum, pageSize) => {
                        this.onPaginationChange(pageNum, pageSize);
                    }}
                    // 当前页数
                    current={params.pageNum}
                    // 禁用分页
                    disabled={false}
                    // 默认的当前页数
                    defaultCurrent={1}
                    // 默认的每页条数
                    defaultPageSize={10}
                    // 只有一页时是否隐藏分页器
                    hideOnSinglePage={false}
                    // 指定每页可以显示多少条
                    pageSizeOptions={['10', '20', '30', '40']}
                    // 每页条数
                    pageSize={params.pageSize}
                    // 数据总数
                    total={total}
                    // 用于显示数据总量和当前数据顺序
                    showTotal={(total) => `共 ${total} 条`}
                />
            </div>
        )
    }

    render() {
        const {visible, activityTypeItem, dataSource} = this.state;
        const {styleOut = {}} = this.props;
        return (
            <>
                <Modal
                    visible={visible}
                    className='historical-release-modal'
                    title={activityTypeItem.name + "账号"}
                    maskClosable={false}
                    keyboard={false}
                    onCancel={() => this.close()}
                    width={"70%"}
                    bodyStyle={{
                        paddingBottom: 0
                    }}
                    cancelText={"关闭"}
                    okButtonProps={{
                        style: {display: "none"}
                    }}
                    centered
                    afterClose={() => {
                        // 弹窗关闭后重置数据
                        this.sortWay.reset();
                        this.setState({
                            params: {
                                pageNum: 1,
                                pageSize: 10,
                                query: "",
                            },
                            activityTypeItem: {},
                            dataSource: [],
                            total: 0,
                        })
                    }}
                >
                    <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
                        {this.renderSearchTemplate()}
                        <Scrollbars autoHeight autoHeightMax={"583px"}>
                            {this.renderTableTemplate()}
                        </Scrollbars>
                        {
                            dataSource.length > 0 && this.renderPagination()
                        }
                    </div>
                </Modal>
            </>
        )
    }

    open(record) {
        this.setState({
            visible: true,
            activityTypeItem: record
        }, () => {
            let annualReviewData=this.props.annualReviewData;
            if(annualReviewData&&annualReviewData.status===0){
                this.columns = this.columns.filter(item => item.dataIndex !== 'annualAuditTime');
            }
            this.getEntryListData();
        })
    }

    close() {
        this.setState({
            visible: false,
        })
    }

    onSearch(params) {
        this.setState({
            params: {
                ...this.state.params,
                ...params,
                pageNum: 1,
                pageSize: 10,
            }
        }, () => {
            this.getEntryListData();
        })
    }

    reset() {
        this.sortWay.reset();
        this.setState({
            params: {
                ...this.state.params,
                query: "",
            }
        }, () => {
            this.getEntryListData();
        })
    }

    // 获取历史发布数据
    getEntryListData() {
        let sortObj = this.sortWay && this.sortWay.getData();
        const {params, activityTypeItem} = this.state;
        let obj = {
            order: "createTime",
            sort: -1,
            ...sortObj
        };
        request({
            url: "/cm-sites-media-consumer/position/management/listByActivity",
            body: {...params, ...obj},
            method: "get",
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res && res.data && res.data.length > 0) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({
                    dataSource,
                    total,
                })
            }
        })
    }

    // 分页Change
    onPaginationChange(current, pageSize) {
        const {params, total} = this.state;
        if (current > 1 && ((current - 1) * pageSize >= total)) {
            this.setState({
                params: {
                    ...params,
                    pageNum: current - 1,
                    pageSize: pageSize,
                },
            }, () => {
                this.getEntryListData();
            })
        } else {
            this.setState({
                params: {
                    ...params,
                    pageNum: current,
                    pageSize: pageSize,
                },
            }, () => {
                this.getEntryListData();
            })
        }
    }
}

export default EntryList;